<script>

export default {
  name: 'PageView',
  template: '#page-template',
  data () {
    return this.$getViewModel();
  }
};

</script>
